import SingleElementIntersectionObserver from './single-element-intersection-observer';

// const defOptions = {
// };

const lastChildVisibleRatio = 0.1;

export default class InfiniteScrollObserver {
  constructor(handler, options) {
    // this._opt = Object.assign({}, defOptions, options);
    this._handler = handler;

    // register MutationObserver to detect any changes in container.
    this._containerMutationObserver = new MutationObserver(this._onContentChanged.bind(this));

    // register SingleElementIntersectionObserver to detect the first child is visible or not.
    this._firstChildObserver = new SingleElementIntersectionObserver(this._onFirstChildVisible.bind(this), {threshold: 0.1});

    // register SingleElementIntersectionObserver to detect the last child is visible or not.
    this._lastChildObserver = new SingleElementIntersectionObserver(this._onLastChildIntersect.bind(this), {
      once: false,
      visibleOnly: false,
      threshold: lastChildVisibleRatio
    });

    this._onScrollListener = this._onScroll.bind(this);
  }

  observe(containerElm) {
    this._stickToEnd = true;
    this._isScrollEnd = true;
    this.unobserve();

    this._container = containerElm;
    this._container.addEventListener('scroll', this._onScrollListener);
    this.scrollToEnd();

    this._visibleObserver = new IntersectionObserver((entries, observer) => {
      let isVisible = true;
      entries.forEach(entry => {
        isVisible = entry.intersectionRatio >= 0.9 && isVisible;
      });

      if (isVisible) {
        this._connect();
      } else {
        this._disconnect();
      }
    }, {threshold: 0.9});

    this._visibleObserver.observe(this._container);
  }

  unobserve() {
    this._disconnect();
    if (this._container) {
      this._visibleObserver.disconnect();
      this._container.removeEventListener('scroll', this._onScrollListener);
    }
  }

  scrollToEnd() {
    this._container.scrollTop = this._container.scrollHeight;
  }

  get stickToEnd() {
    return this._stickToEnd;
  }

  set stickToEnd(v) {
    return this._stickToEnd = !!v;
  }

  get isScrollEnd() {
    return this._isScrollEnd;
  }

  _connect() {
    if (!this._container) {
      return;
    }
    this._containerMutationObserver.observe(this._container, {attributes: false, childList: true, subtree: false})
    this._firstChildObserver.observe(this._container.firstChild);
    this._lastChildObserver.observe(this._container.lastChild);
  }

  _disconnect() {
    this._containerMutationObserver.disconnect();
    this._firstChildObserver.disconnect();
    this._lastChildObserver.disconnect();
  }

  _onContentChanged(mutationList) {
    let container = this._container;
    if (this._isScrollEnd) {
      this.scrollToEnd();
    }

    // re-observe first and last child because they could not be the same when content is changed.
    this._firstChildObserver.observe(container.firstChild);
    this._lastChildObserver.observe(container.lastChild);
  }

  _onFirstChildVisible(entry) {
    this._handler(entry);
  }

  _onLastChildIntersect(entry) {
    // if last message is visible
    if (this._stickToEnd || entry.intersectionRatio >= lastChildVisibleRatio) {
      this._isScrollEnd = true;
    } else {
      this._isScrollEnd = false;
    }
  }

  _onScroll() {
    this._stickToEnd = false;
    // IMPORTANT !!
    // keep a small distance to the top so that prepend nodes
    // will expand space automatically.
    if (this._container.scrollTop < 5) {
      this._container.scrollTop = 5;
    }
  }
}